<template>
<div>

<v-snackbar
v-model="init.sb.snackbar"
:color="init.sb.color"
center top
:timeout="2000"
>
{{ init.sb.text  }}
<v-btn dark flat @click="init.sb.snackbar = false">ОК</v-btn>
</v-snackbar>


<v-dialog v-model="init.modals.creator" width="900" persistent scrollable>
<creatorWrapper :init="init"></creatorWrapper>
</v-dialog>

<v-dialog v-model="init.modals.deleteBot" width="450" persistent>
<deleteBot :init="init"></deleteBot>
</v-dialog>




<v-layout d-flex>
<v-card>
<v-toolbar height="52" flat>
<v-icon large color="#4A76A8" left>mdi-telegram</v-icon>
<v-toolbar-title>Telegram tools</v-toolbar-title>
<v-spacer></v-spacer>
<v-tooltip top  max-width="250">
   <span>Кликните, что бы добавить бота</span>
   <v-btn @click="openCreator()" slot="activator" icon  color="#273C51"  flat > <v-icon>mdi-plus</v-icon></v-btn>
</v-tooltip>

</v-toolbar>
<v-card-text>

<botList :init="init" :bot="bot"></botList>

</v-card-text>

</v-card>
</v-layout>


</div>
</template>




<script>
import creatorWrapper from './creatorWrapper.vue'
import botList from './botList.vue'
import deleteBot from './deleteBot.vue'
import axios from 'axios'
export default {
components:{creatorWrapper,botList,deleteBot},
data(){
return {

init:{
isCreator:true,
modals:{
creator:false,
deleteBot:false,
},
sb:{ snackbar: false, color: 'success', text: ''},
bot_list:[],
selected:{},

bot: {
id:"",
name:"",

user_params:{
token:"",
channelId:"",
userId:""
},
params:{
link_creating:false,
},
alert_list:{
is:true,
accounts:{
is:true,
},
tasks:{
is:true,
},
parser:{
is:true,
},
activiti:{
is:true,
},
antigate:{
is:true,
},
},
active:false,
},

},



}
},


created(){
this.getBots()
},



methods:{

openCreator(){
this.init.modals.creator = true
},

getBots(){
axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/telega/get_bots.php', {
contentType: 'JSONP',
method: 'get',
}).then(response => {
this.init.bot_list  = response.data.bot_list
})
},




  updateAccounts: function(){
    axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/resources/antigate/accounts_get.php', {
      contentType: 'JSONP',
       method: 'get',
       }).then(response => {
      if(response.data == null){
        this.account.keyy = null
        this.account.balance = null

 } else {
   this.getBalance()
   this.account.keyy = response.data.keyy
   this.account.balance = response.data.balance
 }
       })

  },


  addAnti: function(){
   this.addingAnti = true
    axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/resources/antigate/add.php', {
       method: 'POST',
       data: {
         keyy: this.account.newKey
       }
       }).then(response => {
         this.addingAnti = false
         if(response.data.status ==  1 ){
           this.updateAccounts()
           this.sb.color = 'success'
           this.sb.text = 'Ключ успешно добавлен'
           this.sb.snackbar = true
         } else {
           this.sb.color = 'error'
           this.sb.text = 'Извини бро, но ключ не верный ((('
           this.sb.snackbar = true
         }

       })

  },




}
}
</script>

<style>

</style>
